import { PinwheelExperienceInput } from '@varo/graphql-schema-types';

export enum PinwheelSolutionType {
  DirectDeposit = 'direct_deposit',
  BillSwitch = 'bill_switch',
  BillManager = 'bill_manager',
}

export const categoryForSolutionType = (
  solutionType: PinwheelSolutionType,
): string => {
  switch (solutionType) {
    case PinwheelSolutionType.DirectDeposit:
      return 'direct_deposit';
    case PinwheelSolutionType.BillSwitch:
      return 'bill_switch';
    case PinwheelSolutionType.BillManager:
      return 'bill_manager';
    default:
      return 'unknown';
  }
};

export const solutionTypeForExperience = (
  experience: PinwheelExperienceInput,
): PinwheelSolutionType => {
  switch (experience) {
    case PinwheelExperienceInput.BillSwitch:
      return PinwheelSolutionType.BillSwitch;
    case PinwheelExperienceInput.BillManager:
      return PinwheelSolutionType.BillManager;
    case PinwheelExperienceInput.DirectDepositSwitch:
      return PinwheelSolutionType.DirectDeposit;
    default:
      return PinwheelSolutionType.DirectDeposit;
  }
};
